// extracted by mini-css-extract-plugin
export var dropdownContainer = "_rj-0";
export var leftAlign = "_rj-4";
export var listItem = "_rj-2";
export var listItemWrapper = "_rj-1";
export var operationText = "_rj-3";